const React = require('react');
const _ = require('underscore');
const moment = require('moment-timezone');
const ReactRedux = require('react-redux');
const BuildStatus = require('../components/BuildStatus.jsx');
const DeployStatus = require('../components/DeployStatus.jsx');

const actions = require('../_actions.js');
const deployStates = require('../constants/deployment.js');


const UpcomingDeployments = function(props) {
	let errorRow = null;

	if (props.error) {
		errorRow = (
			<tr className="danger">
				<td colSpan="5">
					{props.error}
				</td>
			</tr>
		);
	}

	if (props.list.length === 0 && errorRow === null) {
		return null;
	}

	return (
		<div className="fade-in">
			<h4>Upcoming</h4>
			<div className="table-responsive">
				<table className="table table-fullwidth table-clickable table-centered-columns table-hover table-deployments">
					<thead>
						<tr>
							<th>Scheduled date</th>
							<th>Build details</th>
							<th>Requested by</th>
							<th>Approval</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						{errorRow}
						{
							Object.keys(props.list).map(function(i) {
								const row = props.list[i];

								let approver = null;
								let deployer = null;
								if (row.deployer) {
									deployer = row.deployer.name;
								}
								if (row.approver) {
									approver = row.approver.name;
								} else if (deployStates.isApproved(row.state)) {
									approver = (
										<span className="bypassed">Bypassed</span>
									);
								}

								let date_scheduled = null;
								if (row.schedule_start_unix && row.state === 'Approved') {
									// Times are stored relative to the server's timezone, find the difference between that and the users timezone
									// Use this rather than moment().tz() as this converts from the browsers timezone which may not be the same as the server
									const now = moment().tz(props.user.server_timezone);
									const localOffset = now.utcOffset();
									now.tz(props.user.timezone);
									const centralOffset = now.utcOffset();
									const unix_diff_hours = (localOffset - centralOffset) * 60;
									date_scheduled = moment.unix(row.schedule_start_unix - unix_diff_hours);
								}

								return (
									<tr className={"fade-in status-" + row.state} onClick={() => props.onItemClick(row.id)} key={i}>
										<td>{date_scheduled ? date_scheduled.format('DD/MM/YYYY h:mma') + " (" + props.user.timezone + ")" : "-"}</td>
										<td className="table-cell--multi-line"><BuildStatus deployment={row} commitAsLink={false} /></td>
										<td>{deployer}</td>
										<td className="deploy-approver">{approver}</td>
										<td className="deploy-status">
											<DeployStatus locked={row.locked_by} state={row.state} />
										</td>
									</tr>
								);
							})
						}
					</tbody>
				</table>
			</div>
		</div>
	);
};

const mapStateToProps = function(state) {

	// try to find the current build in the list of all deployments
	let upcomingList = [];
	if (typeof state.deployment.list === "object") {
		upcomingList = _.filter(state.deployment.list, function(deploy) {
			switch (deploy.state) {
				case undefined:
				case deployStates.STATE_COMPLETED:
				case deployStates.STATE_INVALID:
				case deployStates.STATE_FAILED:
				case deployStates.STATE_REJECTED:
				case deployStates.STATE_DELETED:
					return false;
				default:
					return true;
			}
		});
	}
	upcomingList.sort(function(a, b) {
		return b.date_created_unix - a.date_created_unix;
	});

	return {
		list: upcomingList,
		user: state.user
	};
};

const mapDispatchToProps = function() {
	return {
		onItemClick: function(id) {
			actions.history.push('/deployment/' + id.toString());
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(UpcomingDeployments);
